import Controller from "./ticket.controller";
import template from "./ticket.html";

const ticket = {
  template,
  controller: Controller,
};

export default ticket;



// WEBPACK FOOTER //
// ./src/pages/ticket/ticket.component.js